import { push } from "./gtm";
import { PORTAL } from "@ducks/config";
import { IItem, REDEEMTYPE } from "@ducks/listing/types";

export enum PORTALNAME {
  rewards = "Reward",
  promotions = "Promotion",
}

const content_type = PORTALNAME[PORTAL] || "";

export enum ITEMSTATUS {
  starting = "Starting Soon",
  available = "Available",
  awaiting = "Awaiting Redemption",
  redeemed = "Redeemed",
  expired = "Expired",
}

export enum REDEEMEVENT {
  redeem = "Redeem",
  proceed = "Proceed",
  proceedWithCode = "Proceed WITH Verify Code",
  proceedWithoutCode = "Proceed WITHOUT Verify Code",
  cancelProceed = "Cancel Proceed",
  verified = "Verified",
  accountSecurity = "Account Security Notice",
  accountSample = "Account Sample",
  offerReady = "Offer Ready",
  shopNow = "Shop Now",
  barcode = "Offer Ready To Scan",
  copyCode = "Copy Code",
  hideCode = "Hide Code",
  alreadyRedeemed = "Reward Already Redeemed",
  showRedeemed = "Show",
  interested = "Interested",
  thankYou = "Thank You",
  error = "Error - Failed",
  loading = "Loading",
}

export const trackSort = (sortType: string): void =>
  push({
    event: "sortEvent",
    content_type,
    method: sortType,
  });

export const trackShowItem = (
  item: IItem | null,
  content_status: ITEMSTATUS
): void => {
  if (!item) return;
  const content_category = item.typeOfIntegration
    ? item.typeOfIntegration
    : item.redeemType === REDEEMTYPE.online
    ? "Redeem Online"
    : item.redeemType === REDEEMTYPE.offline
    ? "Redeem at Participating Store"
    : "NA";
  push({
    event: "viewEvent",
    content_type,
    content_title: item.title,
    content_id: item.code,
    content_category,
    content_author: item.vendor.name,
    content_status,
  });
};

export const trackRedeemEvent = (
  item: IItem | null,
  stage: REDEEMEVENT
): void => {
  if (!item) return;
  const content_category = item.typeOfIntegration
    ? item.typeOfIntegration
    : item.redeemType === REDEEMTYPE.online
    ? "Redeem Online"
    : item.redeemType === REDEEMTYPE.offline
    ? "Redeem at Participating Store"
    : "NA";
  push({
    event: "redeemEvent",
    redeem_stage: stage,
    content_type,
    content_title: item.title,
    content_id: item.code,
    content_category,
    content_author: item.vendor.name,
  });
};

export const trackNoRewards = (): void => {
  push({
    event: "viewEvent",
    content_type,
    content_title: "No Rewards Available",
    content_id: "No Rewards Available",
    content_category: "NA",
    content_author: "NA",
    content_status: "NA",
  });
};

export const trackBreadcrumb = (
  content_title: string,
  content_id: number
): void => {
  push({
    event: "navEvent",
    content_type,
    content_title,
    content_list_type: "Breadcrumb",
    content_category: "NA",
    content_id,
  });
};

export const trackLink = (
  item: IItem | null,
  url: string,
  content_title: string
): void => {
  if (!item) return;
  push({
    event: "clickEvent",
    content_type,
    content_list_type: "Link Click",
    content_title,
    content_category: "",
    content_id: url,
    content_name: item.title,
  });
};

export const trackSecondaryCta = (url: string, content_title: string): void => {
  push({
    event: "clickEvent",
    content_type,
    content_list_type: "WhatsApp us",
    content_title,
    content_id: url,
  });
};

export const trackShortFormSubmission = (content_title: string): void => {
  push({
    event: "submitEvent",
    content_type,
    content_list_type: "Short Form",
    content_title,
  });
};

export const trackShortFormSubmissionSuccess = (
  content_title: string
): void => {
  push({
    event: "submitSuccess",
    content_type,
    content_list_type: "Short Form",
    content_title,
  });
};

export const trackShortFormSubmissionFailure = (
  content_title: string,
  error_title: string
): void => {
  push({
    event: "submitFailed",
    content_type,
    content_list_type: "Short Form",
    content_title,
    error_desc: error_title,
  });
};

export const trackCategoryChange = (content_title: string): void => {
  push({
    event: "navigation",
    item_category: PORTALNAME.promotions,
    item_list: "Main Category Navigation",
    item_name: content_title,
  });
};

export const trackListingItem = (
  content_title: string,
  url: string,
  category: string
): void => {
  push({
    event: "clickEvent",
    content_type,
    content_list_type: category,
    content_title,
    content_id: url,
  });
};

export const trackExploreSection = (
  content_title: string,
  url: string
): void => {
  push({
    event: "clickEvent",
    content_type,
    content_list_type: "Latest Promotions Widget",
    content_title,
    content_id: url,
  });
};
